"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertCentsAmount = exports.convertCentsToUnits = exports.getParsedAmountInCents = void 0;
/**
 * Converts a string or number amount to an integer amount in cents.
 * @param amount The amount to convert.
 */
const getParsedAmountInCents = (amount) => {
    const value = typeof amount === "string" ? parseFloat(amount) : amount;
    if (!Number.isFinite(value)) {
        throw new Error(`getParsedAmountInCents: invalid amount "${amount}"`);
    }
    return Math.round(value * 100);
};
exports.getParsedAmountInCents = getParsedAmountInCents;
const convertCentsToUnits = (amount) => amount / 100;
exports.convertCentsToUnits = convertCentsToUnits;
function convertCentsAmount(amount, currency) {
    const parsed = parseFloat(((amount || 0) / 100).toString())
        .toFixed(2)
        .toString();
    return `${parsed} ${currency}`;
}
exports.convertCentsAmount = convertCentsAmount;
//# sourceMappingURL=cents.js.map